import React from "react";
import { Tooltip } from "@mui/material";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";

const numberFormat = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 1 });
const responseLabel = (hours) => {
  if (hours < 1 / 60) return "<1 min";
  if (hours < 1) return `${numberFormat.format(hours * 60)} min`;
  if (hours < 24) return `${numberFormat.format(hours)} hrs`;
  return `${numberFormat.format(hours / 24)} days`;
};

export default function VendorResponseMetrics({ insight, status }) {
  const loading = status === "loading" || status === "idle";
  const average = insight?.averageResponseHours;
  const historyReady = status === "ready" && Boolean(insight);
  const hasResponse = historyReady && Number.isFinite(average) && average >= 0;
  const responseColor = average <= 4 ? "bg-emerald-50 text-emerald-700"
    : average <= 12 ? "bg-yellow-50 text-yellow-800" : "bg-red-50 text-red-700";

  return <>
    <td className="whitespace-nowrap px-3 py-3 align-middle text-xs">
      {loading ? <span role="status" className="text-gray-400">Loading...</span> : hasResponse ? (
        <Tooltip title={`Average first response across ${insight.responseSampleCount} RFQ(s), using recorded invitation and submission dates.`}>
          <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 font-semibold ${responseColor}`}>
            <BoltRoundedIcon aria-hidden="true" sx={{ fontSize: 14 }} />
            Avg. {responseLabel(average)}
          </span>
        </Tooltip>
      ) : <span title={status === "error" ? "Supplier history is temporarily unavailable." : "No RFQs with valid invitation and first-submission dates."}>-</span>}
    </td>
    <td className="px-3 py-3 text-center align-middle text-[13px] font-semibold text-gray-900">
      {loading ? <span role="status" className="font-normal text-xs text-gray-400">Loading...</span>
        : historyReady ? <Tooltip title="Number of RFQs with a submitted quotation. Revisions are counted once per RFQ."><span>{numberFormat.format(insight.submittedRfqCount)}</span></Tooltip> : "-"}
    </td>
  </>;
}
